// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__ngNSh","header":"ErrorPage_header__o6zU5","headerMsg":"ErrorPage_headerMsg__lazyJ","content":"ErrorPage_content__hd8_4"};